import React from 'react';

const Bookmark = ({selected = false, title}) => {
    if (!selected) {
        return (
            <svg viewBox="0 0 16 24">
                {title && <title>{title}</title>}
                <path d="M12.5 0h-9c-1.657 0-3 1.35-3 3.014v19.477c-.001.401.158.785.44 1.07a1.497 1.497 0 0 0 1.997.107l4.126-3.317v-.002a1.495 1.495 0 0 1 1.874 0l4.126 3.317v.002a1.497 1.497 0 0 0 1.997-.107 1.51 1.51 0 0 0 .44-1.07V3.014c0-.8-.315-1.565-.879-2.13A2.985 2.985 0 0 0 12.501 0z" />
            </svg>
        );
    }
    return (
        <svg viewBox="0 0 15 24">
            {title && <title>{title}</title>}
            <path d="M12 0c.796 0 1.558.317 2.121.883.564.566.879 1.332.879 2.131v19.477a1.51 1.51 0 0 1-.44 1.07 1.497 1.497 0 0 1-1.997.107v-.002L8.437 20.35a1.495 1.495 0 0 0-1.874 0v.002l-4.126 3.317A1.497 1.497 0 0 1 .44 23.56 1.509 1.509 0 0 1 0 22.49V3.014A3.007 3.007 0 0 1 3 0h9zM9.915 9.54l1.941-1.676c.275-.239.133-.705-.227-.725l-2.5-.16a.395.395 0 0 1-.34-.257l-.92-2.461a.385.385 0 0 0-.729 0l-.918 2.451a.395.395 0 0 1-.342.258l-2.51.16c-.359.019-.5.485-.226.723l1.941 1.668c.114.1.17.268.133.417l-.635 2.55c-.085.358.284.646.587.447l2.112-1.42a.358.358 0 0 1 .417 0l2.12 1.42c.304.199.673-.09.588-.447l-.635-2.54a.419.419 0 0 1 .143-.407z" />
        </svg>
    );
};

export default Bookmark;
